// NOTE: 非核心逻辑进行抽离主干业务 只是调整展示逻辑
import { throttle } from 'lodash'
import { onUnmounted } from 'vue'
import { nextTick, onMounted, ref } from 'vue'

// 滚动时候让头部样式变化
const useUIHooks = () => {
  const isStuck = ref(false)
  const headerRef = ref()
  const containerRef = ref()
  const HEADER_TOP = 100
  const onScroll = throttle(() => {
    if (!containerRef.value || !headerRef.value) return
    if (containerRef.value.scrollTop > HEADER_TOP) {
      isStuck.value = true
    } else if (containerRef.value.scrollTop === 0) {
      isStuck.value = false
    }
  }, 100)

  onMounted(() => {
    nextTick(() => {
      if (containerRef.value && headerRef.value) {
        containerRef.value.addEventListener('scroll', onScroll, { passive: true })
      }
    })
  })
  onUnmounted(() => {
    if (containerRef.value) containerRef.value.removeEventListener('scroll', onScroll)
  })
  return { isStuck, headerRef, containerRef }
}
export { useUIHooks }
